package one.healthium.insights.domain.models

data class TextStyleModel(
    val color: ColorModel? = null,
    val fontWeight: String? = null,
    val fontStyle: String? = null,
    val fontSize: Int? = null,
    val alignment: String? = null,
)
